import { isError } from '../isError';

export const parseErrorMsg = (error: unknown): string => {
	if (isError(error)) {
		return error.message;
	}

	if (typeof error === 'string') {
		return error;
	}

	return JSON.stringify(error);
};
